import { apiFetch } from './core'

/**
 * Timeline unifiée: événements manuels + échéances paiement + prestations
 * @param {string} from - Date début (YYYY-MM-DD)
 * @param {string} to - Date fin (YYYY-MM-DD)
 * @param {string|null} eventType - Filtre par type (MEETING, CALL, TASK, DEADLINE, PAYMENT_DUE, PRESTATION_DUE, etc.)
 * @param {string[]|null} sources - Sources à inclure (AGENDA, PAYMENT_DUE, PRESTATION_DUE)
 * @returns {Promise<Array>} Liste d'événements normalisés
 */
export async function fetchAgendaTimeline(from, to, eventType = null, sources = null) {
  const params = new URLSearchParams()
  params.set('from', from)
  params.set('to', to)
  if (eventType) params.set('eventType', eventType)
  if (sources && sources.length) params.set('sources', sources.join(','))

  return apiFetch(`/api/agenda/timeline?${params.toString()}`)
}

/**
 * @deprecated Utiliser fetchAgendaTimeline à la place
 */
export async function fetchAgendaEvents(startDate, endDate, eventType = null) {
  const params = new URLSearchParams()
  params.set('start_date', startDate)
  params.set('end_date', endDate)
  if (eventType) params.set('event_type', eventType)

  return apiFetch(`/api/agenda?${params.toString()}`)
}

export async function fetchAgendaEvent(id) {
  return apiFetch(`/api/agenda/${id}`)
}

export async function createAgendaEvent(data) {
  return apiFetch('/api/agenda', {
    method: 'POST',
    body: data,
  })
}

export async function updateAgendaEvent(id, data) {
  return apiFetch(`/api/agenda/${id}`, {
    method: 'PATCH',
    body: data,
  })
}

export async function deleteAgendaEvent(id) {
  return apiFetch(`/api/agenda/${id}`, {
    method: 'DELETE',
  })
}
